<mat-toolbar color="primary">
  <mat-toolbar-row>
    @if (!cyddiedMewngofnodi && !dangosBotwm) {
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="toggle()">
        <fa-icon icon="bars"></fa-icon>
      </button>
    }

    @if (enwTenant$ | async; as tenant) {
      @if (tenant) {
        <img alt="Asedau Fflyd" class="navbar-logo" [src]="nolLogo()" />
      }
    }

    <span class="spacer"></span>

    @if (prawf) {
      <span class="prawf"><fa-icon icon="flask" class="mr-2"></fa-icon> {{ "ui.fersiwnprawf" | translate }}</span>
    }

    <div color="primary" class="dropdown-iaith" [matMenuTriggerFor]="help" matRipple>
      <fa-icon icon="circle-question"></fa-icon>
    </div>
    <mat-menu #help="matMenu">
      <button mat-menu-item (click)="desgGymorth()"><fa-icon icon="circle-question"></fa-icon> {{ "ui.cymorth" | translate }}</button>
    </mat-menu>

    <div color="primary" class="dropdown-iaith" [matMenuTriggerFor]="newidiaith" matRipple>
      <fa-icon icon="language"></fa-icon>
    </div>
    <mat-menu #newidiaith="matMenu">
      <button mat-menu-item (click)="newidIaith('cy')"><fa-icon icon="flag" class="mr-2"></fa-icon> Cymraeg</button>
      <button mat-menu-item (click)="newidIaith('en')"><fa-icon icon="flag" class="mr-2"></fa-icon> English</button>
    </mat-menu>

    @if (wediMewngofnodi()) {
      <app-navbar-defnyddiwr></app-navbar-defnyddiwr>
    }

    @if (!wediMewngofnodi() && !cyddiedMewngofnodi) {
      <button mat-raised-button color="accent" (click)="mewngofnodi()">
        <fa-icon icon="right-to-bracket"> </fa-icon>
      </button>
    }
  </mat-toolbar-row>
</mat-toolbar>
<app-llwythwr></app-llwythwr>
